import type { IconSvgObject } from './types';

const ChartRingIcon: IconSvgObject = [
  ["path", { d: "M9 9L5 5M16 12H22M12 16V22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default ChartRingIcon;
